module.exports = __webpack_public_path__ + "img/soya.df4a1262.png";